<div class="auth auth-dark" #scrollHost (scroll)="onAuthScroll($event)">
  <!-- Background photo + brand-green gradient overlay live in .auth (CSS). -->
  <span class="auth__glow" aria-hidden="true"></span>

  <!-- Fixed glassmorphism brand bar (full-width); content capped by __inner -->
  <nav class="auth__nav" [class.is-scrolled]="scrolled()">
    <div class="auth__nav-inner">
      <a routerLink="/" class="auth__logo-link" aria-label="Gozem">
        <img src="/images/partner_black.png" alt="Gozem Partner" class="auth__logo" />
      </a>

      <div class="auth__lang" role="group" [attr.aria-label]="langLabel()">
        <button
          type="button"
          class="auth__lang-btn"
          [class.is-active]="locale() === 'en'"
          [attr.aria-pressed]="locale() === 'en'"
          (click)="setLocale('en')"
        >
          EN
        </button>
        <button
          type="button"
          class="auth__lang-btn"
          [class.is-active]="locale() === 'fr'"
          [attr.aria-pressed]="locale() === 'fr'"
          (click)="setLocale('fr')"
        >
          FR
        </button>
      </div>
    </div>
  </nav>

  <!-- Content: mobile stacks the form near the bottom; ≥1024px shows the hero beside it -->
  <main class="auth__main">
    <div class="auth__grid">
      <section class="auth__hero">
        <span class="auth__badge">
          <i class="ri-flashlight-line" aria-hidden="true"></i>
          {{ heroExtras().badge }}
        </span>
        <h1 class="auth__title">{{ t().auth.login.heroTitle }}</h1>
        <p class="auth__subtitle">{{ t().auth.login.heroSubtitle }}</p>
        <ul class="auth__trust">
          @for (item of heroExtras().trust; track item.label) {
            <li class="auth__trust-item">
              <i [class]="item.icon" aria-hidden="true"></i>
              <span>{{ item.label }}</span>
            </li>
          }
        </ul>
      </section>

      <div class="auth__form">
        <router-outlet (activate)="onRouteActivate(scrollHost)"></router-outlet>
      </div>
    </div>
  </main>
</div>
